(function () {
  var Q = [
    { k: 'tasima', t: 'Bisikleti sık sık kaldırman gerekecek mi?',
      h: 'Merdiven, metro, araç bagajı. Yük taşımakla ilgisi yok — onu ayrıca sormuyoruz.',
      o: [['sik', 'Evet, düzenli olarak', 'Merdiven, metro veya servis aracı'],
          ['arasira', 'Ara sıra araç bagajına koyacağım', ''],
          ['yok', 'Hayır, hep zeminde kalacak', 'Garaj, bahçe, apartman girişi']] },
    { k: 'agir', t: 'Sürücü ve yük toplamı 110 kg’ı aşıyor mu?',
      h: 'Modellerin taşıma limiti 100 ile 120 kg arasında değişiyor.',
      o: [['hayir', 'Hayır', ''], ['evet', 'Evet', '120 kg limitli modeller gerekir']] },
    { k: 'zemin', t: 'Çoğunlukla hangi zeminde süreceksin?', h: '',
      o: [['asfalt', 'Düzgün asfalt, bisiklet yolu', ''],
          ['bozuk', 'Bozuk şehir yolu, parke, kasis', ''],
          ['stabilize', 'Stabilize, sıkışmış toprak, sahil yolu', ''],
          ['arazi', 'Gerçek arazi veya trafiğe kapalı parkur', '']] },
    { k: 'mesafe', t: 'Bir şarjla kaç km gitmen gerekiyor?',
      h: 'Menzili yalnız batarya kapasitesinden değil, zemin ve yokuş cevaplarınla birlikte hesaplıyoruz.',
      o: [['az', '15 km’den az', ''], ['orta', '15 – 25 km', ''],
          ['uzun', '25 – 40 km', ''], ['cok', '40 km üzeri', '']] },
    { k: 'kadro', t: 'Alçak girişli (step-thru) kadro senin için önemli mi?',
      h: 'Bacağını yüksek üst borunun üzerinden atmadan binmek.',
      o: [['farketmez', 'Fark etmez', ''], ['alcak', 'Evet, önemli', 'Kolay iniş ve biniş']] },
    { k: 'yokus', t: 'Güzergâhında yokuş var mı?',
      h: 'Tırmanmayı tek başına Nm belirlemiyor — torkun teker çapına ve toplam ağırlığa oranı belirliyor. Motor gücü hepsinde 250 W.',
      o: [['duz', 'Neredeyse hep düz', ''], ['orta', 'Orta eğimli yokuşlar', '%7 – 11'],
          ['dik', 'Dik yokuş var', '%12 ve üzeri']] },
    { k: 'butce', t: 'Bütçen ne kadar?', h: '',
      o: [['a', '45.000 TL’ye kadar', ''], ['b', '45.000 – 55.000 TL', ''],
          ['c', '55.000 – 70.000 TL', ''], ['d', '70.000 TL üzeri veya fark etmez', '']] },
    { k: 'oncelik', t: 'Eşit çıkarsa hangisi öncelikli?', h: '',
      o: [['hafif', 'En hafif olsun', ''], ['menzil', 'En uzun menzil', ''],
          ['cekis', 'En güçlü çekiş', ''], ['donanim', 'En iyi donanım', 'Hidrolik fren, süspansiyon, alarm']] }
  ];

  function init(root) {
    var bikes;
    try { bikes = JSON.parse(root.querySelector('[data-asis-veri]').textContent); }
    catch (e) { return; }
    var stokDisi = bikes.filter(function (b) { return !b.satilabilir; });
    bikes = bikes.filter(function (b) { return b.satilabilir; });
    if (!bikes.length) { root.hidden = true; return; }

    var A = window.AlbaAsistan, ans = {}, sorulan = [];
    var box = root.querySelector('[data-asis-govde]');
    var esc = function (t) { var d = document.createElement('div'); d.textContent = t == null ? '' : t; return d.innerHTML; };
    var sayi = function (n) { return String(n).replace('.', ','); };
    var kume = function (a) {
      var r = A.sirala(a, bikes);
      return r.slice(0, 3).map(function (t) { return t.b.id; }).sort().join('|');
    };

    function sonraki() {
      for (var i = 0; i < Q.length; i++) {
        var q = Q[i];
        if (sorulan.indexOf(q.k) !== -1) continue;
        var set = {}, n = 0;
        for (var j = 0; j < q.o.length; j++) {
          var a2 = {}; for (var k in ans) a2[k] = ans[k];
          a2[q.k] = q.o[j][0];
          var s = kume(a2);
          if (!set[s]) { set[s] = 1; n++; }
        }
        if (n > 1) return q;
        sorulan.push(q.k);
      }
      return null;
    }

    function soruEkrani(q) {
      var tot = sorulan.filter(function (k) { return ans[k] !== undefined; }).length + 2;
      var i = sorulan.filter(function (k) { return ans[k] !== undefined; }).length;
      var h = '<div class="albaasis__prog"><div class="albaasis__bar"><i style="width:' +
        Math.round(i / tot * 100) + '%"></i></div><span class="albaasis__step">' + (i + 1) + '. soru</span></div>' +
        '<h3 class="albaasis__q h3">' + esc(q.t) + '</h3>' +
        (q.h ? '<p class="albaasis__hint">' + esc(q.h) + '</p>' : '') +
        '<div class="albaasis__opts' + (q.o.length > 3 ? ' albaasis__opts--two' : '') + '">';
      q.o.forEach(function (o) {
        h += '<button type="button" class="albaasis__opt" data-q="' + esc(q.k) + '" data-v="' + esc(o[0]) + '">' +
          '<b>' + esc(o[1]) + '</b>' + (o[2] ? '<span>' + esc(o[2]) + '</span>' : '') + '</button>';
      });
      h += '</div><div class="albaasis__nav">';
      if (sorulan.length) h += '<button type="button" class="albaasis__link" data-act="geri">← Geri</button>';
      h += '</div>';
      return h;
    }

    function kart(t, rol, ik) {
      var b = t.b, x = t.x;
      var etiket = { top: 'Size uygun', eko: 'Daha ekonomik', guc: 'Daha donanımlı', alt: 'Diğer seçenek', onc: 'Bu dönem öne çıkan' }[rol];
      var why = x.why.length ? x.why : (b.ozet ? [b.ozet] : []);
      var h = '<div class="albaasis__card' + (rol === 'top' ? ' albaasis__card--top' : '') + '">' +
        '<span class="albaasis__tag' + (rol === 'top' ? '' : ' albaasis__tag--alt') + '">' + etiket + '</span>';
      if (b.img) h += '<a class="albaasis__img" href="' + esc(b.url) + '"><img src="' + esc(b.img) +
        '" alt="' + esc(b.ad) + '" width="600" height="400" loading="lazy"></a>';
      h += '<h4 class="albaasis__name">' + esc(b.ad) + '</h4>' +
        '<p class="albaasis__price">' + esc(b.fiyatMetin) + '</p>' +
        '<p class="albaasis__meta">' + esc(b.tip + ' · ' + sayi(b.kg) + ' kg · ' + b.wh + ' Wh' + (b.nmLabel ? ' · ' + b.nmLabel : '')) + '</p>';
      if (rol === 'top') h += '<p class="albaasis__meta">' + esc(A.guven(t, ik)) + '</p>';
      if (why.length) {
        h += '<ul class="albaasis__why">';
        why.slice(0, 3).forEach(function (w) { h += '<li>' + esc(w) + '</li>'; });
        h += '</ul>';
      }
      if (x.warn.length) {
        h += '<ul class="albaasis__warn">';
        x.warn.slice(0, 2).forEach(function (w) { h += '<li>' + esc(w) + '</li>'; });
        h += '</ul>';
      }
      h += '<div class="albaasis__cta"><a class="button button--full-width" href="' + esc(b.url) +
        '">Modeli incele</a></div></div>';
      return h;
    }

    function stokNotu(kartlar) {
      if (!stokDisi.length) return '';
      var ilgili = stokDisi;
      if (ans.tasima === 'sik' || ans.tasima === 'arasira') {
        ilgili = ilgili.filter(function (b) { return b.kat; });
      }
      if (ans.agir === 'evet') {
        ilgili = ilgili.filter(function (b) { return !b.maks || b.maks >= 110; });
      }
      if (!ilgili.length) return '';
      var gerekce = '';
      if (ans.oncelik === 'hafif') {
        var enHafif = ilgili.reduce(function (p, c) { return c.kg < p.kg ? c : p; });
        var secilenEnHafif = kartlar.reduce(function (p, c) { return c[0].b.kg < p[0].b.kg ? c : p; })[0].b;
        if (enHafif.kg < secilenEnHafif.kg) {
          gerekce = ' Gamın en hafif modeli ' + enHafif.ad + ' (' + sayi(enHafif.kg) + ' kg), şu an stokta olmadığı için listede değil.';
        }
      } else if (ans.oncelik === 'menzil') {
        var enUzun = ilgili.reduce(function (p, c) { return c.wh > p.wh ? c : p; });
        var secilenEnUzun = kartlar.reduce(function (p, c) { return c[0].b.wh > p[0].b.wh ? c : p; })[0].b;
        if (enUzun.wh > secilenEnUzun.wh) {
          gerekce = ' Daha yüksek kapasiteli ' + enUzun.ad + ' (' + enUzun.wh + ' Wh) şu an stokta değil.';
        }
      }
      var adlar = ilgili.map(function (b) { return b.ad; }).join(', ');
      return '<p class="albaasis__hint">Stokta olmayan modeller öneri dışında tutuldu: ' +
        esc(adlar) + '.' + esc(gerekce) + '</p>';
    }

    function sonuc() {
      var r = A.sirala(ans, bikes);
      if (!r.length) return '<p class="albaasis__hint">Bu cevaplarla eşleşen model bulunamadı.</p>';
      var best = r[0], ik = r[1];
      var eko = null, guc = null, i;
      for (i = 1; i < r.length; i++) {
        if (r[i].b.fiyat < best.b.fiyat) { eko = r[i]; break; }
      }
      for (i = 1; i < r.length; i++) {
        if (r[i] === eko) continue;
        if (r[i].b.fiyat > best.b.fiyat &&
            (r[i].b.wh > best.b.wh || (r[i].b.nm && best.b.nm && r[i].b.nm > best.b.nm))) { guc = r[i]; break; }
      }
      var kartlar = [[best, 'top']];
      if (eko) kartlar.push([eko, 'eko']);
      if (guc) kartlar.push([guc, 'guc']);
      for (i = 1; i < r.length && kartlar.length < 3; i++) {
        var v = false;
        for (var j = 0; j < kartlar.length; j++) if (kartlar[j][0] === r[i]) v = true;
        if (!v) kartlar.push([r[i], 'alt']);
      }
      var idler = kartlar.map(function (p) { return p[0].b.id; });
      var slot = null;
      for (i = 1; i < r.length; i++) {
        if (r[i].b.onc > 0 && idler.indexOf(r[i].b.id) === -1) { slot = r[i]; break; }
      }
      var h = '<h3 class="albaasis__q h3">Size uygun ' + kartlar.length + ' model</h3>' +
        '<p class="albaasis__hint">Sıralama cevaplarına göre; her kartta neden önerildiği yazıyor.</p>' +
        '<div class="albaasis__res' + (slot ? ' albaasis__res--four' : '') + '">';
      kartlar.forEach(function (p) { h += kart(p[0], p[1], p[0] === best ? ik : null); });
      if (slot) h += kart(slot, 'onc', null);
      h += '</div>';
      h += stokNotu(kartlar);
      h += '<div class="albaasis__nav">' +
        '<button type="button" class="albaasis__link" data-act="geri">← Son cevabı değiştir</button>' +
        '<button type="button" class="albaasis__link" data-act="bas">Baştan başla</button></div>';
      return h;
    }

    function ciz() {
      var q = sonraki();
      box.innerHTML = q ? soruEkrani(q) : sonuc();
      box.querySelectorAll('.albaasis__opt').forEach(function (btn) {
        btn.addEventListener('click', function () {
          ans[btn.dataset.q] = btn.dataset.v;
          if (sorulan.indexOf(btn.dataset.q) === -1) sorulan.push(btn.dataset.q);
          ciz();
        });
      });
      box.querySelectorAll('[data-act]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.dataset.act === 'bas') { ans = {}; sorulan = []; }
          else {
            for (var i = sorulan.length - 1; i >= 0; i--) {
              if (ans[sorulan[i]] !== undefined) { delete ans[sorulan[i]]; sorulan.splice(i, 1); break; }
              sorulan.splice(i, 1);
            }
          }
          ciz();
        });
      });
    }
    ciz();
  }

  function basla() {
    document.querySelectorAll('[data-alba-asistan]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', basla);
  else basla();
  document.addEventListener('shopify:section:load', basla);
})();
